import { validarCPFCNPJ } from "./validar-cpfcnpj"
import { removerMascaraDocumento } from "./cpfcnpj-format"
import { stringNumeros } from "./string-numeros"

export const validarDocumentoTelefoneEmail = (campo: string) => {
    const normalizado = removerMascaraDocumento(campo)
    if (normalizado && validarCPFCNPJ(normalizado)) {
        return {
            cpfCnpj: normalizado
        }
    }
    const letrasENumeros = campo.replace(/[^a-zA-Z0-9]/g, '')
    const apenasDigitos = campo.replace(/[^0-9]/g, '')
    if (/^[0-9]+$/.test(letrasENumeros)) {
        return {
            telefone: stringNumeros(apenasDigitos)
        }
    } else {
        return {
            email: campo
        }
    }
}
